import { render, staticRenderFns } from "./OptionSelect.vue?vue&type=template&id=68fb2976"
import script from "./OptionSelect.vue?vue&type=script&lang=ts"
export * from "./OptionSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports